import { ModelBase, observable } from "@shoothill/core";
import { computed } from "mobx";
import { InductionQualificationDTO, InductionPersonalProtectiveEquipmentDTO } from "../InductionAdminItemModel";
import { PersonalProtectiveEquipment } from "Globals/Models/Enums/PersonalProtectiveEquipment";
import { PersonalProtectiveEquipmentType } from "Globals/Models/Enums/PersonalProtectiveEquipmentType";

export class InductionAdminEditModel extends ModelBase<InductionAdminEditModel> {
    @observable
    public id: string = "";

    @observable
    public fullName: string = "";

    @observable
    public firstName: string = "";

    @observable
    public lastName: string = "";

    @observable
    public supplierId: string | null = null;

    @observable
    public priorityEmployerName: string = "";

    @observable
    public photographUrl: string = "";

    @observable
    public visitorTypeId: string = "";

    @observable
    public visitorTypeName: string = "";

    @observable
    public visitorTypeType: number | null = null;

    @observable
    public age: number = 0;

    @observable
    public confirmOver18: boolean = false;

    @observable
    public confirmAdjustments: boolean = false;

    @observable
    public adjustmentDetails: string | null = null;

    @observable
    public healthProblems: boolean = false;

    @observable
    public healthDetails: string | null = null;

    @observable
    public skillsTrainingOrQualifications: InductionQualificationDTO[] = [];

    @observable
    public plantAndEquipmentTrainingOrQualifications: InductionQualificationDTO[] = [];

    @observable
    public personalProtectiveEquipment: PersonalProtectiveEquipment[] = [];

    @observable
    public personalProtectiveEquipmentTypes: PersonalProtectiveEquipmentType[] = [];

    @observable
    public selectedPersonalProtectiveEquipmentTypes: PersonalProtectiveEquipmentType[] = [];

    @computed
    public get isValid() {
        for (const ppe of this.personalProtectiveEquipment) {
            if (this.selectedPersonalProtectiveEquipmentTypes.findIndex((ppeType: PersonalProtectiveEquipmentType) => ppeType.personalProtectiveEquipmentId === ppe.id) === -1) {
                return false;
            }
        }
        return true;
    }

    @observable
    public general: boolean = false;

    @observable
    public trainingAndEquipment: boolean = false;

    @observable
    public ppe: boolean = false;

    @observable
    public rams: boolean = false;

    @observable
    public housekeeping: boolean = false;

    @observable
    public rulesDiscipline: boolean = false;

    @observable
    public siteSpecificBriefing: boolean = false;

    @observable
    public signatureURL: string = "";

    @observable
    public inductionStatusId: string = "";

    @observable
    public createdAt: string = "";

    @observable
    public isDeleted: boolean = false;

    @computed
    public get isWorker() {
        if (this.visitorTypeType === null || this.visitorTypeType === undefined) {
            return false;
        }

        if (this.visitorTypeType === 10 || this.visitorTypeType === 20) {
            return false;
        }

        return true;
    }

    fromDto(dto: any): void {
        for (const key in dto) {
            if (dto.hasOwnProperty(key)) {
                this[key] = dto[key];
            }
        }
    }

    toDto(): any {
        const dto: any = {};
        for (const key in this) {
            if (this.hasOwnProperty(key)) {
                dto[key] = this[key];
            }
        }
        return dto;
    }
}
